import httpClient from '../index';

const END_POINT = 'logout';

const logout = () => httpClient.post(`${END_POINT}`, null);

export { logout };
